<template>
  <layout-fullpage>
    <page-headline tag="h1" title="收據檔案驗證" />
    <loading :show="apiLoading" />
    <!-- 手機版 -->
    <div class="d-lg-none">
      <b-card
        no-body
        class="mb-3"
        v-for="(item, index) in tabledatas"
        :key="`RESULT_LIST_MOBILE__${index}`"
      >
        <!-- <b-card-header header-bg-variant="primary" header-text-variant="white">
          序號：{{ index + 1 }}
        </b-card-header> -->
        <b-table-simple id="itemList" borderless striped class="mb-0">
          <colgroup>
            <col width="90" />
            <col />
          </colgroup>
          <b-tbody>
            <b-tr>
              <b-th>檔案名稱</b-th>
              <b-td>{{ item.name }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>收據號碼</b-th>
              <b-td>{{
                item.reason === null || item.reason === undefined
                  ? ''
                  : JSON.parse(item.reason).rpPublicNo
              }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>驗證結果</b-th>
              <b-td>
                <span class="mr-2" :class="[item.isVerifyOK ? 'text-info' : 'text-danger']">
                  <i class="fas fa-fw" :class="[item.isVerifyOK ? 'fa-check' : 'fa-times']" />
                </span>
                <span>{{ item.isVerifyOK ? '正確' : '錯誤' }}</span>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>已作廢</b-th>
              <b-td>{{ item.isInvalid ? '已作廢' : '' }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-card-footer v-if="item.isVerifyOK">
          <b-row>
            <b-col>
              <b-button variant="action" block class="m-1" @click="showDetails(item, index)"
                >明細</b-button
              >
            </b-col>
            <b-col v-if="!item.isInvalid">
              <b-button variant="action" block class="m-1" @click="getReceipt(item)">預覽</b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </div>

    <!-- 電腦版 -->
    <div class="d-none d-lg-block">
      <b-table-simple id="itemList" caption-top responsive striped table-class="table-rounded">
        <caption class="sr-only">
          收據查詢結果
        </caption>

        <b-thead head-variant="primary">
          <b-tr>
            <b-th>檔案名稱</b-th>
            <b-th>驗證結果</b-th>
            <b-th>收據號碼</b-th>
            <b-th>已作廢</b-th>
            <b-th class="text-center">操作</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in tabledatas" :key="`RESULT_LIST__${index}`">
            <b-td>{{ item.name }}</b-td>
            <b-td>
              <span
                class="mr-2 align-middle"
                :class="[item.isVerifyOK ? 'text-info' : 'text-danger']"
                style="font-size: 1.25rem"
              >
                <i class="fas fa-fw" :class="[item.isVerifyOK ? 'fa-check' : 'fa-times']" />
              </span>
              <span class="align-middle">{{ item.isVerifyOK ? '正確' : '錯誤' }}</span>
            </b-td>
            <b-td>{{
              item.reason === null || item.reason === undefined
                ? ''
                : JSON.parse(item.reason).rpPublicNo
            }}</b-td>
            <b-td>{{ item.isInvalid ? '已作廢' : '' }}</b-td>
            <b-td class="text-nowrap text-center">
              <template v-if="item.isVerifyOK">
                <b-button variant="action" size="sm" class="m-1" @click="showDetails(item, index)"
                  >明細</b-button
                >
                <b-button
                  v-if="!item.isInvalid"
                  variant="action"
                  size="sm"
                  class="m-1"
                  @click="getReceipt(item, index)"
                  >預覽</b-button
                >
              </template>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div>
      <b-pagination
        align="center"
        pills
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="itemList"
        class="justify-content-center"
      ></b-pagination>
    </div>

    <div>
      <div class="row align-items-center text-center mb-4 small">
        <div class="col-12 col-md mb-2 mb-md-0">
          <!-- <b-button variant="primary" size="sm" class="btn-miw mx-1 mt-2" @click="goHome"
            >回收據雲平台首頁</b-button
          > -->
          <go-home-btn
            :btnSize="'sm'"
            :btnClass="'btn-miw mx-1 mb-2'"
            :btnVariant="'primary'"
            :btnName="'回收據雲平台首頁'"
          >
            <template slot="goHomeBtn"></template>
          </go-home-btn>
        </div>
      </div>
    </div>

    <!-- 收據明細 -->
    <detail-modal ref="detailData"></detail-modal>
    <!-- 收據預覽 -->
    <receipt-preview :isDownloadBtn="false" ref="receiptPreview"></receipt-preview>
  </layout-fullpage>
</template>

<script>
import Loading from '@/components/Loading.vue';
import LayoutFullpage from '@/layouts/Fullpage.vue';
import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import MakePdf from '@/mixins/makePdf';
import UserMixin from '@/mixins/user';

export default {
  name: 'UploadResult',

  components: {
    LayoutFullpage,
    Loading,
  },

  mixins: [ApiMixin, CommonApiMixin, UserMixin, MakePdf],

  data() {
    return {
      currentPage: 1,
      perPage: 5, // 分頁

      pagination: {
        prePage: 1,
      },

      receiptFile: {
        imagePath: 'mock/receipts/preview.jpg',
        pdfPath: 'mock/receipts/preview.pdf',
      },
      resultData: [],
      rpPublicNo: '',
      rpPublicRandomCode: '',
      getCookieRunVal: '',
      detailData: [],
      apiLoading: false,
    };
  },
  created() {
    this.resultData = this.$store.getters['details/getDetailData'];

    // this.resultData.forEach((element) => {
    //   const reason = JSON.parse(element.reason);
    //   const item = element;
    //   console.log('reason', reason);

    //   if (reason.rpStatus === '9') {
    //     item.isInvalid = true;
    //   } else {
    //     item.isInvalid = false;
    //   }
    // });
    // let isEmpty = Object.keys(this.resultData).length === 0;
    // console.log('resultData-', this.resultData);
    // if (this.resultData.length === 0 || Object.keys(this.resultData).length === 0) {
    //   this.goHome();
    // }
  },

  computed: {
    rows() {
      return this.resultData.length;
    },
    tabledatas() {
      return this.resultData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },

  methods: {
    // 使用共用API結果
    success(type, result, otherObj) {
      console.log(otherObj);
      switch (type) {
        case 'receiptQuerySelectBox': // 下拉選單
          // eslint-disable-next-line no-case-declarations
          const selectData = result.data.object;
          this.organList = selectData.organList;
          this.payItemList = selectData.payItemList;
          break;
        case 'Query':
          console.log(result.data.object[0]);
          this.showDetailReason(result.data.object[0]);
          break;
        case 'ReceiptQuery':
          // console.log('ReceiptQuery', result.data.object[0].pdfNym);
          this.previewReceipt(result.data.object[0]);
          break;
        default:
          break;
      }
    },
    fail(type, error) {
      console.log(error);
      switch (type) {
        // case 'upData':
        //   console.log('upData', error);
        //   this.showApiMessage('error', '歸戶失敗', '訊息');
        //   break;
        default:
          break;
      }
      this.apiLoading = false;
    },
    showDetails(rowData) {
      const { rpPublicNo } = JSON.parse(rowData.reason);
      const { rpPublicRandomCode } = JSON.parse(rowData.reason);
      this.rpPublicNo = rpPublicNo;
      this.rpPublicRandomCode = rpPublicRandomCode;
      console.log(rpPublicNo, rpPublicRandomCode);
      const data = {
        rpPublicNo,
        rpPublicRandomCode,
      };

      const url = '/GovEReceipt/FrontDeskService/QueryFNTSF';
      this.axiosServiceSend(data, url, 'post', 'Query');
    },
    showDetailReason(item) {
      this.$refs.detailData.getDetailData(item);
    },
    getReceipt(item) {
      console.log('item', item);
      const { rpPublicNo } = JSON.parse(item.reason);
      const { rpPublicRandomCode } = JSON.parse(item.reason);
      console.log('rpPublicNo:', rpPublicNo);
      console.log('rpPublicRandomCode:', rpPublicRandomCode);
      const data = {
        rpPublicNo,
        rpPublicRandomCode,
      };
      this.axiosServiceSend(
        data,
        '/GovEReceipt/FrontDeskService/QueryFNTSF',
        'post',
        'ReceiptQuery'
      );
    },
    // 瀏覽
    previewReceipt(rowData) {
      const pdfnym = rowData.pdfNym;
      const data = {
        rpPublicNo: rowData.rpPublicNo,
        rpPublicRandomCode: rowData.rpPublicRandomCode,
      };
      const url = {
        preview: `/GovEReceipt/PdfService/previewPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
        downloadPdf: `/GovEReceipt/PdfService/downloadPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
      };
      this.$refs.receiptPreview.showModal(data, url);
    },
    goHome() {
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>
